import { useAdminGet } from '@reapitform/hooks'
import { AdminFieldLink, IResponseWithPagination } from '../types'

export const ADMIN_FIELD_LINKS_QUERY_KEY = ['admin-field-links']

/** Loads every form-field-to-recipient-field mapping for a version (`GET …/versions/{ref}/field-links`). */
export const useAdminFieldLinks = (formReferenceID?: string, versionReferenceID?: string) => {
  const [result, loading, errorString, refresh] = useAdminGet<IResponseWithPagination<AdminFieldLink>>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}/field-links?pageNumber=1&pageSize=2000`,
    retry: false,
    queryKeys: [...ADMIN_FIELD_LINKS_QUERY_KEY, formReferenceID ?? '', versionReferenceID ?? ''],
    fetchWhenTrue: [Boolean(formReferenceID), Boolean(versionReferenceID)],
  })

  return { data: result?._embedded ?? [], loading, errorString, refresh }
}
